import React from 'react';

import { ItemPropsI } from './types';
import { Box } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { P } from '@osmosis/react-ui/components/Text';

export const Item = React.memo(
  React.forwardRef<HTMLLIElement, ItemPropsI>(
    (
      {
        dragOverlay,
        dragging,
        index,
        listeners,
        transition,
        transform,
        value,
        ordered,
        sx,
        icon,
        textSx,
        orderedSx,
        customRender,
        as = 'span',
      },
      ref,
    ) => {
      const color = useColors();
      const { x = 0, y = 0, scaleX = 1, scaleY = 1 } = transform || {};
      return (
        <Box
          as={as}
          sx={{
            ':hover': {
              cursor: dragOverlay ? 'grabbing' : 'grab',
            },
            transform: `translate3d(${Math.round(x)}px, ${Math.round(
              y,
            )}px, 0) scaleX(${Math.round(scaleX)}) scaleY(${Math.round(
              scaleY,
            )})`,
            transition,
            ...(dragging && {
              opacity: 0.7,
              backgroundColor: `${color.gray10} !important`,
            }),
            ...sx,
            backgroundColor: 'bg-0',
          }}
          ref={ref}
          tabIndex={0}
          {...listeners}
        >
          {customRender ? (
            customRender({
              value: value as any,
              index: index as any,
              ordered: ordered as any,
            }) // FIXME: any
          ) : (
            <>
              <P sx={textSx}>
                {ordered && (
                  <Box as="span" sx={orderedSx}>
                    {/* // FIXME: any */}
                    {(index as any) + 1}
                  </Box>
                )}
                {value}
              </P>
              {icon}
            </>
          )}
        </Box>
      );
    },
  ),
);
